import { BaseApi } from './base.api'

export class EmailAdminApi extends BaseApi {
	constructor() {
		super('api/admin/email')
	}

	async getSESStatus() {
		return this.get('/ses/status')
	}

	async getTemplates({ page = 0, pageSize = 20, status, emailType, q } = {}) {
		const searchParams = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(pageSize),
		})
		if (status) searchParams.set('status', status)
		if (emailType) searchParams.set('emailType', emailType)
		if (q) searchParams.set('q', q)
		return this.get(`/templates?${searchParams.toString()}`)
	}

	async getTemplate(id) {
		return this.get(`/templates/${id}`)
	}

	async createTemplate(data) {
		return this.post('/templates', data)
	}

	async updateTemplate(id, data) {
		return this.put(`/templates/${id}`, data)
	}

	async deleteTemplate(id) {
		return this.delete(`/templates/${id}`)
	}

	async sendEmail(data) {
		return this.post('/send', data)
	}

	async getSendJobStatus(jobID) {
		return this.get(`/send/jobs/${jobID}`)
	}

	async getSendJobDetail(jobID) {
		return this.get(`/send/jobs/${jobID}/detail`)
	}

	async listSendJobs({
		page = 0,
		pageSize = 20,
		status,
		emailType,
		templateId,
		q,
		from,
		to,
	} = {}) {
		const searchParams = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(pageSize),
		})
		if (status) searchParams.set('status', status)
		if (emailType) searchParams.set('emailType', emailType)
		if (templateId) searchParams.set('templateId', String(templateId))
		if (q) searchParams.set('q', q)
		if (from) searchParams.set('from', from)
		if (to) searchParams.set('to', to)
		return this.get(`/send/jobs?${searchParams.toString()}`)
	}

	async listSendJobRecipients(jobID, { page = 0, pageSize = 20, status, q } = {}) {
		const searchParams = new URLSearchParams({
			pageNum: String(page),
			pageSize: String(pageSize),
		})
		if (status) searchParams.set('status', status)
		if (q) searchParams.set('q', q)
		return this.get(`/send/jobs/${jobID}/recipients?${searchParams.toString()}`)
	}

	async cancelSendJob(jobID) {
		return this.post(`/send/jobs/${jobID}/cancel`, {})
	}
}
